import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateVehicleModelPayload, VehicleModelItem } from '../api/vehicles';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class VehicleModelsService {
    private baseUrl: string = '/admin/vehicle-makes/';

    constructor(private http: HttpClient) {}

    createModel(
        makeId: string,
        payload: CreateVehicleModelPayload
    ): Observable<any> {
        return this.http.post<any>(
            this.baseUrl.concat(makeId).concat('/models'),
            payload
        );
    }

    getAllModels(makeId: string): Observable<VehicleModelItem[]> {
        return this.http.get<VehicleModelItem[]>(
            this.baseUrl.concat(makeId).concat('/models')
        );
    }

    deleteModel(makeId: string, modelId: string): Observable<any> {
        return this.http.delete(
            this.baseUrl.concat(makeId).concat('/models/').concat(modelId)
        );
    }
}
